<template>
  <div class="c-survey__inner c-survey__bg--blue">
    <div class="c-survey__content c-survey__content--padding">
      <main v-html="pageTwo.content" class="c-survey__html"></main>
      <div class="c-survey__accordion">
        <div
          class="c-survey__accordion-item"
          v-for="(section, index) in sections"
          :key="index"
        >
          <!-- Start Loop -->
          <div
            class="c-survey__accordion-item-header"
            @click="toggleDescription(`${index}Visible`)"
            :style="{ backgroundColor: section.sectionColour }"
          >
            <h2 class="white-text c-survey__accordion-item-title">{{ section.label }}</h2>
            <div
              :class="[
                'c-survey__accordion-indicator',
                sectionsVisibility[`${index}Visible`]
                  ? 'c-survey__accordion-indicator--active'
                  : '',
              ]"
            ></div>
          </div>
          <transition
            name="accordion-slide-fade"
            @before-enter="beforeEnter"
            @enter="enter"
            @leave="leave"
          >
            <div
              v-if="sectionsVisibility[`${index}Visible`]"
              class="c-survey__accordion-item-content"
              :style="{ backgroundColor: section.sectionColour }"
            >
              <div class="c-survey__accordion-content-wrapper">
                <main
                  v-html="section.description"
                  class="c-survey__html"
                ></main>
              </div>
            </div>
          </transition>
          <!-- End Loop -->
        </div>
      </div>
      <div
        class="c-survey__actionbutton-row c-survey__actionbutton-row--center"
      >
        <ActionButton
          :title="pageTwo.prevLabel"
          :buttonAction="'prev'"
          :arrowLeft="true"
          :muted="true"
        ></ActionButton>
        <ActionButton
          :title="pageTwo.nextLabel"
          :buttonAction="'next'"
        ></ActionButton>
      </div>
    </div>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import ActionButton from "../ActionButton.vue";

export default {
  data() {
    return {
      sectionsVisibility: {
        sectionOneVisible: false,
        sectionTwoVisible: false,
        sectionThreeVisible: false,
      },
    };
  },
  computed: {
    ...mapFields([
      "content.settings",
      "content.sections",
      "content.pages.pageTwo",
    ]),
  },
  components: { ActionButton },
  methods: {
    toggleDescription(section) {
      console.log(section);
      const currentState = this.sectionsVisibility[section];
      Object.keys(this.sectionsVisibility).forEach((key) => {
        this.sectionsVisibility[key] = false;
      });
      this.sectionsVisibility[section] = !currentState;
    },
    beforeEnter(el) {
      el.style.display = "none";
    },
    enter(el, done) {
      $(el).slideDown(500, done);
    },
    leave(el, done) {
      $(el).slideUp(500, done);
    },
  },
};
</script>
